import React from 'react';
import { useForm, UseFormReturn } from 'react-hook-form';
import { useParams, useLocation } from 'react-router';
import { BLoCBase, BLoCParams, renderBlocChild } from 'types/BLoCBase';
import { useBLoC } from 'hooks/useBLoC';
import { useInitBloc } from 'hooks/useInitBloc';
import { $post } from 'services/api';
import { navigate } from 'services/navigate';

type State = {};
class FormValues {
  public password: string = '';
  public passwordConfirmation: string = '';
  public token: string = '';
  public email: string = '';
}

class BLoC extends BLoCBase<State> {
  constructor(public readonly form: UseFormReturn<FormValues, object>) {
    super({});
  }

  public handleSubmit = this.form.handleSubmit((data) => {
    $post('reset-password/reset', data).subscribe({
      complete: () => navigate('/password/reset-finished'),
    });
  });
}

const Context = React.createContext<Readonly<BLoC>>({} as any);

export const usePasswordChangePageBLoC = () => useBLoC<BLoC>(Context);

export const PasswordChangePageBLoC: React.FC<BLoCParams<BLoC, State>> = ({ children }) => {
  const { token } = useParams<{ token: string }>();
  const searchParams = new URLSearchParams(useLocation().search);
  const form = useForm({
    defaultValues: Object.assign(new FormValues(), {
      token,
      email: searchParams.get('email'),
    }),
    mode: 'all',
  });
  const bloc = useInitBloc(() => new BLoC(form));
  return bloc ? <Context.Provider value={bloc}>{renderBlocChild(children, bloc)}</Context.Provider> : null;
};
